import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import AccordionDetails from '@material-ui/core/AccordionDetails';

interface Props {
  children: React.ReactNode;
}

function AccordionSectionContent({ children }: Props) {
  const classes = useStyles();
  return <AccordionDetails className={classes.accordionContent}>{children}</AccordionDetails>;
}

const useStyles = makeStyles(theme => ({
  root: {},
  accordionContent: {
    flexDirection: 'column',
    padding: 0,
    margin: 0,
  },
}));

export default AccordionSectionContent;
